import state from './moduleProductManagementState.js'
import mutations from './moduleProductManagementMutations.js'
import actions from './moduleProductManagementActions.js'
import getters from './moduleProductManagementGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

